module.exports = __webpack_public_path__ + "static/media/men_brainstorm.4e4d50e5.png";